window.GRAVOTAC_EXT = {
  "1/8": [
    { refId: 31837, color: "PINE GREEN", price: 100.00 },
    { refId: 32295, color: "ALMOND", price: 310.00 },
    { refId: 31648, color: "CHOCOLATE BROWN", price: 302.00 },
    { refId: 31700, color: "RED", price: 170.00 },
    { refId: 32187, color: "SILVER GREY", price: 168.00 },
    { refId: 31406, color: "AZURE BLUE", price: 156.00 },
    { refId: 72083, color: "CLEAR", price: 155.00 },
    { refId: 31738, color: "BURGUNDY", price: 145.00 },
    { refId: 31237, color: "EXTRA WHITE", price: 100.00 },
    { refId: 31257, color: "BLACK", price: 100.00 },
    { refId: 32277, color: "SLATE", price: 100.00 }
  ],
    "1/16": [
    { refId: 29943, color: "CHOCOLATE BROWN", price: 142.00 },
    { refId: 29903, color: "TEAL", price: 58.82 },
    { refId: 29944, color: "PINE GREEN", price: 153.00 },
    { refId: 29938, color: "ALMOND", price: 142.00 },
    { refId: 29946, color: "SILVER GREY", price: 91.00 },
    { refId: 29939, color: "RED", price: 81.00 },
    { refId: 29945, color: "AZURE BLUE", price: 79.00 },
    { refId: 29940, color: "BURGUNDY", price: 73.00 },
    { refId: 29935, color: "CLEAR", price: 60.00 },
    { refId: 29936, color: "EXTRA WHITE", price: 58.82 },
    { refId: 29937, color: "BLACK", price: 58.82 },
    { refId: 29947, color: "SLATE", price: 58.82 },
    { refId: 45961, color: "MAUI BLUE", price: 81.00 },
    { refId: 78948, color: "PURPLE", price: 157.00 }
  ],
   "1/32": [
    { refId: 81282, color: "NAVY BLUE", price: 71.00 },
    { refId: 81281, color: "YELLOW", price: 58.00 },
    { refId: 29931, color: "SILVER", price: 81.00 },
    { refId: 29932, color: "GOLD", price: 92.00 },
    { refId: 29918, color: "CLEAR", price: 52.94 },
    { refId: 29919, color: "EXTRA WHITE", price: 52.94 },
    { refId: 29920, color: "BLACK", price: 52.94 },
    { refId: 78232, color: "BRIGHT WHITE", price: 60.00 },
    { refId: 81363, color: "COPPER", price: 92.00 },
    { refId: 81361, color: "ROYAL BLUE", price: 85.00 },
    { refId: 81368, color: "METALLIC BLUE", price: 77.00 },
    { refId: 81370, color: "METALLIC GREY", price: 77.00 },
    { refId: 81311, color: "COCOA", price: 74.00 },
    { refId: 81310, color: "APPLE GREEN", price: 74.00 },
    { refId: 81312, color: "AIR FORCE BLUE", price: 74.00 },
    { refId: 81313, color: "IVORY", price: 74.00 },
    { refId: 81351, color: "EGGSHELL", price: 74.00 },
    { refId: 81352, color: "BROWN", price: 74.00 },
    { refId: 81353, color: "TAUPE", price: 74.00 },
    { refId: 81354, color: "PURPLE", price: 74.00 },
    { refId: 81355, color: "CREAM", price: 74.00 },
    { refId: 81358, color: "CANDLEWICK", price: 74.00 },
    { refId: 81359, color: "GREEN", price: 74.00 },
    { refId: 81360, color: "BURNT ORANGE", price: 74.00 },
    { refId: 81362, color: "NEW YORK WHITE", price: 74.00 },
    { refId: 81364, color: "LIGHT GREY", price: 74.00 },
    { refId: 81365, color: "RUST", price: 74.00 },
    { refId: 81369, color: "ORANGE", price: 74.00 },
    { refId: 81374, color: "PINK", price: 74.00 },
    { refId: 81371, color: "PATRIOT BLUE", price: 52.94 },
    { refId: 81373, color: "BORDEAUX", price: 52.94 },
    { refId: 81372, color: "MAUI BLUE", price: 52.94 },
    { refId: 29923, color: "BURGUNDY", price: 52.94 },
    { refId: 29921, color: "ALMOND", price: 83.00 },
    { refId: 29922, color: "RED", price: 83.00 },
    { refId: 29926, color: "CHOCOLATE BROWN", price: 83.00 },
    { refId: 29929, color: "SILVER GREY", price: 83.00 },
    { refId: 29927, color: "PINE GREEN", price: 74.00 },
    { refId: 29930, color: "SLATE", price: 74.00 },
    { refId: 29928, color: "AZURE BLUE", price: 52.94 }
  ]
};
window.GRAVOXAL = {
  "0.020": [
    { refId: 34526, color: "RED", finish: "SATIN", price: 22.35 },
    { refId: 34594, color: "GOLD", finish: "GLOSSY", price: 22.35 },
    { refId: 34454, color: "BLACK", finish: "SATIN", price: 22.35 },
    { refId: 34496, color: "AZURE BLUE", finish: "SATIN", price: 22.35 },
    { refId: 34624, color: "BRUSHED SILVER", finish: "SATIN", price: 22.35 }
  ],
  "1/16": [
    { refId: 34619, color: "BRUSHED SILVER", finish: "SATIN", price: 28.24 },
    { refId: 34453, color: "BLACK", finish: "SATIN", price: 28.24 }
  ],
  "1/32": [
    { refId: 34592, color: "GOLD", finish: "GLOSSY", price: 17.65 },
    { refId: 34495, color: "AZURE BLUE", finish: "SATIN", price: 17.65 },
    { refId: 34617, color: "BRUSHED SILVER", finish: "SATIN", price: 17.65 },
    { refId: 34452, color: "BLACK", finish: "SATIN", price: 17.65 },
    { refId: 34519, color: "RED", finish: "SATIN", price: 17.65 }
  ]
};
window.GRAVOTAC_INT = {
  "1/32": [
    { refId: 37047, color: "TAUPE", price: 47.06 },
    { refId: 37060, color: "PINE GREEN", price: 47.06 },
    { refId: 32729, color: "CLEAR", price: 47.06 },
    { refId: 24998, color: "YELLOW", price: 47.06 },
    { refId: 37058, color: "CHOCOLATE BROWN", price: 47.06 },
    { refId: 31631, color: "BROWN", price: 47.06 },
    { refId: 37050, color: "CANDLEWICK", price: 47.06 },
    { refId: 25001, color: "RED", price: 47.06 },
    { refId: 69712, color: "NAVY BLUE", price: 47.06 },
    { refId: 32291, color: "RUST", price: 47.06 },
    { refId: 32726, color: "TAN", price: 47.06 },
    { refId: 37033, color: "WHITE", price: 47.06 },
    { refId: 37048, color: "AZURE BLUE", price: 47.06 },
    { refId: 37032, color: "METALLIC BLUE", price: 47.06 },
    { refId: 37037, color: "BLACK", price: 47.06 },
    { refId: 37065, color: "SLATE", price: 47.06 },
    { refId: 69711, color: "BURGUNDY", price: 73.00 },
    { refId: 69713, color: "SILVER GREY", price: 47.06 },
    { refId: 37042, color: "BRIGHT WHITE", price: 47.06 }
  ],
  "1/16": [
    { refId: 29883, color: "YELLOW", price: 56.00 },
    { refId: 29888, color: "BURGUNDY", price: 52.94 },
    { refId: 29892, color: "CHOCOLATE BROWN", price: 52.94 },
    { refId: 29884, color: "RUST", price: 52.94 },
    { refId: 29889, color: "TAN", price: 52.94 },
    { refId: 29885, color: "RED", price: 52.94 },
    { refId: 29898, color: "NAVY BLUE", price: 52.94 },
    { refId: 29900, color: "SILVER GREY", price: 52.94 },
    { refId: 29899, color: "CANDLEWICK", price: 52.94 },
    { refId: 29880, color: "WHITE", price: 52.94 },
    { refId: 29891, color: "BROWN", price: 52.94 },
    { refId: 29901, color: "SLATE", price: 52.94 },
    { refId: 29882, color: "ALMOND", price: 52.94 },
    { refId: 29896, color: "METALLIC BLUE", price: 52.94 },
    { refId: 29890, color: "TAUPE", price: 52.94 },
    { refId: 29897, color: "AZURE BLUE", price: 52.94 },
    { refId: 29895, color: "PINE GREEN", price: 52.94 },
    { refId: 29879, color: "BRIGHT WHITE", price: 52.94 },
    { refId: 29902, color: "BLACK", price: 52.94 }
  ],
  "1/8": [
    { refId: 31360, color: "NAVY BLUE", price: 94.12 },
    { refId: 32276, color: "SLATE", price: 94.12 },
    { refId: 31236, color: "WHITE", price: 94.12 },
    { refId: 31260, color: "BRIGHT WHITE", price: 94.12 },
    { refId: 31256, color: "BLACK", price: 94.12 },
    { refId: 32727, color: "TAN", price: 99.00 },
    { refId: 32292, color: "RUST", price: 96.00 },
    { refId: 32294, color: "ALMOND", price: 96.00 },
    { refId: 31410, color: "CANDLEWICK", price: 94.12 },
    { refId: 31539, color: "YELLOW", price: 93.00 }
  ]
};
window.GRAVOGLAS_2PLEX_SUBSURFACE_GROUPED = {
  "0.200": [
    { refId: 18104, color: "BLACK / CLEAR", finish: "GLOSSY", price: 198.00 }
  ],
  "1/16": [
    { refId: 17979, color: "COPPER / CLEAR", finish: "GLOSSY", price: 88.24 },
    { refId: 17982, color: "GOLD / CLEAR", finish: "GLOSSY", price: 88.24 },
    { refId: 17991, color: "BLACK / CLEAR", finish: "GLOSSY", price: 88.24 },
    { refId: 17997, color: "RED / CLEAR", finish: "GLOSSY", price: 88.24 },
    { refId: 29656, color: "SILVER GREY / CLEAR", finish: "GLOSSY", price: 88.24 },
    { refId: 17938, color: "AIR FORCE BLUE / CLEAR", finish: "GLOSSY", price: 88.24 },
    { refId: 17985, color: "SILVER / CLEAR", finish: "GLOSSY", price: 88.24 },
    { refId: 18003, color: "YELLOW / CLEAR", finish: "GLOSSY", price: 88.24 },
    { refId: 18000, color: "AZURE BLUE / CLEAR", finish: "GLOSSY", price: 88.24 },
    { refId: 29655, color: "CLEAR / CLEAR", finish: "GLOSSY", price: 88.24 },
    { refId: 17988, color: "WHITE / CLEAR", finish: "GLOSSY", price: 88.24 },
    { refId: 29658, color: "CREAM / CLEAR", finish: "MATTE", price: 79.00 },
    { refId: 29663, color: "AMERICAN BLUE / CLEAR", finish: "MATTE", price: 79.00 },
    { refId: 29665, color: "ROYAL BLUE / CLEAR", finish: "MATTE", price: 87.00 },
    { refId: 29660, color: "COCOA / CLEAR", finish: "MATTE", price: 76.47 },
    { refId: 29659, color: "BORDEAUX / CLEAR", finish: "MATTE", price: 76.47 },
    { refId: 29670, color: "GOLD / CLEAR", finish: "MATTE", price: 76.47 },
    { refId: 29666, color: "METALLIC BLUE / CLEAR", finish: "MATTE", price: 76.47 },
    { refId: 17950, color: "RED / CLEAR", finish: "MATTE", price: 76.47 },
    { refId: 17958, color: "ALMOND / CLEAR", finish: "MATTE", price: 76.47 },
    { refId: 17961, color: "SILVER GREY / CLEAR", finish: "MATTE", price: 76.47 },
    { refId: 17970, color: "CHOCOLATE BROWN / CLEAR", finish: "MATTE", price: 76.47 },
    { refId: 17973, color: "APPLE GREEN / CLEAR", finish: "MATTE", price: 76.47 },
    { refId: 17976, color: "BURGUNDY / CLEAR", finish: "MATTE", price: 76.47 },
    { refId: 29661, color: "TAUPE / CLEAR", finish: "MATTE", price: 76.47 },
    { refId: 29662, color: "GREEN / CLEAR", finish: "MATTE", price: 76.47 },
    { refId: 29667, color: "SLATE / CLEAR", finish: "MATTE", price: 76.47 },
    { refId: 29669, color: "SILVER / CLEAR", finish: "MATTE", price: 76.47 },
    { refId: 33982, color: "EGGSHELL / CLEAR", finish: "MATTE", price: 76.47 },
    { refId: 17956, color: "YELLOW / CLEAR", finish: "MATTE", price: 76.47 },
    { refId: 17953, color: "AZURE BLUE / CLEAR", finish: "MATTE", price: 76.47 },
    { refId: 17941, color: "CLEAR / CLEAR", finish: "MATTE", price: 76.47 },
    { refId: 17944, color: "BLACK / CLEAR", finish: "MATTE", price: 76.47 },
    { refId: 17947, color: "WHITE / CLEAR", finish: "MATTE", price: 76.47 }
  ],
  "1/8": [
      { refId: 33982, color: "EGGSHELL / CLEAR", finish: "MATTE", price: 76.47 },
    { refId: 18024, color: "BLACK / CLEAR", finish: "GLOSSY", price: 126.00 },
    { refId: 18015, color: "ALMOND / CLEAR", finish: "GLOSSY", price: 111.76 },
    { refId: 18030, color: "RED / CLEAR", finish: "GLOSSY", price: 111.76 },
    { refId: 18093, color: "SILVER / CLEAR", finish: "GLOSSY", price: 111.76 },
    { refId: 18021, color: "WHITE / CLEAR", finish: "GLOSSY", price: 111.76 },
    { refId: 33962, color: "AZURE BLUE / CLEAR", finish: "MATTE", price: 121.00 },
    { refId: 18088, color: "RED / CLEAR", finish: "MATTE", price: 111.76 },
    { refId: 18090, color: "BURGUNDY / CLEAR", finish: "MATTE", price: 111.76 },
    { refId: 34406, color: "SILVER GREY / CLEAR", finish: "MATTE", price: 111.76 },
    { refId: 34363, color: "CHOCOLATE BROWN / CLEAR", finish: "MATTE", price: 111.76 },
    { refId: 33977, color: "ALMOND / CLEAR", finish: "MATTE", price: 111.76 },
    { refId: 18082, color: "CLEAR / CLEAR", finish: "MATTE", price: 111.76 },
    { refId: 18084, color: "BLACK / CLEAR", finish: "MATTE", price: 124.00 },
    { refId: 18086, color: "WHITE / CLEAR", finish: "MATTE", price: 111.76 },
    { refId: 34381, color: "GREEN / CLEAR", finish: "MATTE", price: 111.76 },
    { refId: 29657, color: "CLEAR / CLEAR", finish: "GLOSSY", price: 133.00 },
    { refId: 18091, color: "GOLD / CLEAR", finish: "GLOSSY", price: 114.00 },
    { refId: 18036, color: "YELLOW / CLEAR", finish: "GLOSSY", price: 111.76 },
    { refId: 29914, color: "BLACK / WHITE", finish: "MATTE", price: 129.41 }
  ]
};
window.GRAVOLASE = {
  "0.020": [
     { refId: "18960", color: "NEW GOLD / BLACK", finish: "MATTE", price: 64.71 },
    { refId: "75717", color: "EUROPEAN GOLD / SILVER", finish: "MATTE", price: 64.71 },
    { refId: "18968", color: "BRUSHED SILVER / BLUE", finish: "BRUSHED", price: 64.71 },
    { refId: "18961", color: "BRUSHED SILVER / BLACK", finish: "BRUSHED", price: 64.71 },
    { refId: "29543", color: "GOLD / BLACK", finish: "GLOSSY", price: 64.71 },
    { refId: "29544", color: "BRUSHED BRONZE / BLACK", finish: "BRUSHED", price: 64.71 },
    { refId: "29545", color: "BRUSHED BRONZE / WHITE", finish: "BRUSHED", price: 64.71 },
    { refId: "29546", color: "COPPER / BLACK", finish: "MATTE", price: 64.71 },
    { refId: "29548", color: "GLOSSY SILVER / BLACK", finish: "GLOSSY", price: 64.71 }
  ],
  "0.050": [
    { refId: "49985", color: "NEW GOLD / BLACK", finish: "MATTE", price: 69.41 },
    { refId: "51002", color: "MATTE ALUMINUM / BLACK", finish: "MATTE", price: 69.41 },
    { refId: "51004", color: "BRUSHED BRONZE / BLACK", finish: "BRUSHED", price: 69.41 },
    { refId: "49980", color: "GLOSSY SILVER / BLACK", finish: "GLOSSY", price: 69.41 },
    { refId: "49981", color: "BRUSHED ALUMINUM / BLACK", finish: "BRUSHED", price: 69.41 },
    { refId: "49983", color: "RADIANT GOLD / BLACK", finish: "MATTE", price: 69.41 },
    { refId: "49984", color: "GLOSSY GOLD / BLACK", finish: "GLOSSY", price: 69.41 },
    { refId: "49986", color: "RADIANT SILVER / BLACK", finish: "MATTE", price: 69.41 }
  ],
  "1/16": [
    { refId: "19002", color: "GOLD / BLACK", finish: "BRUSHED", price: 70.59 },
    { refId: "19003", color: "BRUSHED SILVER / BLACK", finish: "BRUSHED", price: 70.59 },
    { refId: "29552", color: "EUROPEAN GOLD / BLACK", finish: "MATTE", price: 70.59 },
    { refId: "29554", color: "BRUSHED BRONZE / BLACK", finish: "BRUSHED", price: 70.59 },
    { refId: "29556", color: "COPPER / BLACK", finish: "MATTE", price: 70.59 },
    { refId: "29558", color: "GLOSSY SILVER / BLACK", finish: "GLOSSY", price: 70.59 },
    { refId: "78538", color: "MATTE ALUMINUM / BLACK", finish: "MATTE", price: 82.35 },
    // { refId: "78540", color: "GOLD / BLACK", finish: "BRUSHED", price: 82.35 },
    { refId: "78541", color: "COPPER / BLACK", finish: "BRUSHED", price: 82.35 }
  ],
  "1/32": [
    { refId: "51024", color: "MATTE ALUMINUM / BLACK", finish: "MATTE", price: 67.06 },
    { refId: "51030", color: "EUROPEAN GOLD / BLACK", finish: "MATTE", price: 67.06 },
    { refId: "51031", color: "NEW GOLD / BLACK", finish: "MATTE", price: 67.06 },
    { refId: "51032", color: "BRUSHED BRONZE / BLACK", finish: "BRUSHED", price: 67.06 },
    { refId: "51059", color: "RADIANT SILVER / BLUE", finish: "MATTE", price: 67.06 },
    { refId: "51025", color: "BRUSHED ALUMINUM / BLACK", finish: "BRUSHED", price: 67.06 },
    { refId: "51026", color: "RADIANT SILVER / BLACK", finish: "MATTE", price: 67.06 },
    { refId: "51027", color: "GLOSSY SILVER / BLACK", finish: "GLOSSY", price: 67.06 },
    { refId: "51028", color: "RADIANT GOLD / BLACK", finish: "MATTE", price: 67.06 },
    { refId: "51029", color: "GLOSSY GOLD / BLACK", finish: "GLOSSY", price: 67.06 }
  ]
};

window.GRAVOPLY_2 = {
"0.020": [
    { refId: "53219", color: "RED / WHITE", finish: "MATTE", price: "39.00" },
    { refId: "53220", color: "BLUE / WHITE", finish: "MATTE", price: "39.00" },
    { refId: "53217", color: "BLACK / WHITE", finish: "MATTE", price: "37.65" },
    { refId: "53218", color: "WHITE / BLACK", finish: "MATTE", price: "37.65" },
],
"1/8": [
    { refId: "22016", color: "RED / WHITE", finish: "MATTE", price: "120.00" },
   { refId: "29732", color: "BLACK / WHITE", finish: "MATTE", price: "120.00" },
   { refId: "31405", color: "BLUE / WHITE", finish: "MATTE", price: "117.65" },
],
"1/16": [
    { refId: "21876", color: "CHOCOLATE BROWN / WHITE", finish: "MATTE", price: "85.00" },
    { refId: "29709", color: "ALMOND / BURGUNDY", finish: "MATTE", price: "49.41" },
    { refId: "21936", color: "YELLOW / BLACK", finish: "MATTE", price: "49.41" },
    { refId: "21938", color: "PINE GREEN / WHITE", finish: "MATTE", price: "49.41" },
    { refId: "21926", color: "ALMOND / BLACK", finish: "MATTE", price: "49.41" },
    { refId: "21905", color: "APPLE GREEN / WHITE", finish: "MATTE", price: "49.41" },
    { refId: "21923", color: "BLUE / WHITE", finish: "MATTE", price: "49.41" },
    { refId: "21921", color: "RED / WHITE", finish: "MATTE", price: "49.41" },
    { refId: "21919", color: "WHITE / BLACK", finish: "MATTE", price: "49.41" },
    { refId: "21915", color: "GREY / BLACK", finish: "MATTE", price: "49.41" },
    { refId: "21928", color: "WHITE / RED", finish: "MATTE", price: "49.41" },
    { refId: "21917", color: "BLACK / WHITE", finish: "MATTE", price: "49.41" },
    { refId: "22012", color: "BLUE / WHITE DS", finish: "MATTE", price: "72.94" },
    { refId: "22011", color: "RED / WHITE DS", finish: "MATTE", price: "70.59" },
    { refId: "21932", color: "BURGUNDY / WHITE", finish: "MATTE", price: "49.41" },
    { refId: "21913", color: "YELLOW / RED", finish: "MATTE", price: "49.41" },
    { refId: "22010", color: "WHITE / BLACK DS", finish: "MATTE", price: "70.59" },
    { refId: "21896", color: "YELLOW / BLUE", finish: "MATTE", price: "49.41" },
    { refId: "21907", color: "AIR FORCE BLUE / WHITE", finish: "MATTE", price: "49.41" },
    { refId: "21908", color: "WHITE / AZURE BLUE", finish: "MATTE", price: "49.41" },
    { refId: "21910", color: "RED / YELLOW", finish: "MATTE", price: "49.41" },
    { refId: "21916", color: "PINE GREEN / YELLOW", finish: "MATTE", price: "49.41" },
    { refId: "21925", color: "DARK YELLOW / BLACK", finish: "MATTE", price: "49.41" },
    { refId: "21940", color: "BLACK / YELLOW", finish: "MATTE", price: "49.41" },
    { refId: "22009", color: "BLACK / WHITE DS", finish: "MATTE", price: "70.59" },
    { refId: "21895", color: "SKY BLUE / BLACK", finish: "MATTE", price: "49.41" },
    { refId: "21930", color: "BROWN / WHITE", finish: "MATTE", price: "49.41" },
    { refId: "21934", color: "SKY BLUE / WHITE", finish: "MATTE", price: "49.41" },
    { refId: "23981", color: "WHITE / RED", finish: "GLOSSY", price: "72.94" },
    { refId: "23979", color: "BLUE / WHITE", finish: "GLOSSY", price: "72.94" },
    { refId: "23982", color: "YELLOW / BLACK", finish: "GLOSSY", price: "72.94" },
    { refId: "23983", color: "PINE GREEN / WHITE", finish: "GLOSSY", price: "72.94" },
    { refId: "23977", color: "WHITE / BLACK", finish: "GLOSSY", price: "72.94" },
    { refId: "21874", color: "WHITE / BURGUNDY", finish: "MATTE", price: "49.41" },
    { refId: "23978", color: "RED / WHITE", finish: "GLOSSY", price: "72.94" },
    { refId: "21927", color: "GREY / WHITE", finish: "MATTE", price: "49.41" },
    { refId: "21885", color: "WALNUT / WHITE", finish: "MATTE", price: "47.06" },

],
    "1/32": [
    { refId: "21850", color: "WHITE / BLACK", finish: "MATTE", price: "43.53" },
    { refId: "21863", color: "YELLOW / BLACK", finish: "MATTE", price: "41.18" },
    { refId: "21851", color: "RED / WHITE", finish: "MATTE", price: "43.53" },
    { refId: "21852", color: "BLUE / WHITE", finish: "MATTE", price: "43.53" },
    { refId: "21857", color: "WHITE / RED", finish: "MATTE", price: "43.53" },
    { refId: "21858", color: "BROWN / WHITE", finish: "MATTE", price: "43.53" },
    { refId: "21865", color: "PINE GREEN / WHITE", finish: "MATTE", price: "43.53" },
    { refId: "21838", color: "APPLE GREEN / WHITE", finish: "MATTE", price: "43.53" },
    { refId: "21855", color: "ALMOND / BLACK", finish: "MATTE", price: "43.53" },
    { refId: "21856", color: "GREY / WHITE", finish: "MATTE", price: "43.53" },
    { refId: "21849", color: "BLACK / WHITE", finish: "MATTE", price: "43.53" },
    { refId: "22016", color: "RED / WHITE", finish: "MATTE", price: "120.00" },
    { refId: "29732", color: "BLACK / WHITE", finish: "MATTE", price: "120.00" },
    { refId: "31405", color: "BLUE / WHITE / BLUE", finish: "MATTE", price: "117.65" },
    { refId: "21983", color: "RED / WHITE", finish: "MATTE", price: "78.82" },
    ],

"3/32": [
  { refId: "21983", color: "RED / WHITE", finish: "MATTE", price: "78.82" },
    { refId: "21984", color: "BLUE / WHITE", finish: "MATTE", price: "78.82" },
    { refId: "21997", color: "PINE GREEN / WHITE", finish: "MATTE", price: "78.82" },
    { refId: "21981", color: "BLACK / WHITE", finish: "MATTE", price: "78.82" },
    { refId: "21973", color: "WHITE / AZURE BLUE", finish: "MATTE", price: "78.82" },
    { refId: "21995", color: "YELLOW / BLACK", finish: "MATTE", price: "78.82" },
    { refId: "21982", color: "WHITE / BLACK", finish: "MATTE", price: "78.82" },
    { refId: "21827", color: "SKY BLUE / BLACK", finish: "MATTE", price: "43.53" },
    { refId: "21845", color: "YELLOW / RED", finish: "MATTE", price: "43.53" }
]
};
window.GRAVOPLY_ULTRA = {
  "1/32": [
    { refId: 49884, color: "ULTRA GLOW / WHITE", finish: "MATTE", price: 472.00 }
  ],
  "0.020": [
    { refId: 75716, color: "LACK / SILVER", finish: "GLOSSY", price: 70.59 },
    { refId: 18973, color: "BLACK / GOLD", finish: "GLOSSY", price: 70.59 },
    { refId: 18970, color: "APPLE GREEN / WHITE", finish: "MATTE", price: 70.59 },
    { refId: 18976, color: "BLACK / GOLD", finish: "MATTE", price: 70.59 },
    { refId: 18943, color: "BLACK / WHITE", finish: "MATTE", price: 70.59 },
    { refId: 18952, color: "BLUE / WHITE", finish: "MATTE", price: 70.59 },
    { refId: 18962, color: "CLEAR / BLACK", finish: "MATTE", price: 70.59 },
    { refId: 18965, color: "CLEAR / WHITE", finish: "MATTE", price: 70.59 },
    { refId: 18949, color: "RED / WHITE", finish: "MATTE", price: 70.59 },
    { refId: 70955, color: "SKY BLUE / WHITE", finish: "MATTE", price: 70.59 },
    { refId: 18946, color: "WHITE / BLACK", finish: "MATTE", price: 70.59 },
    { refId: 18955, color: "YELLOW / BLACK", finish: "MATTE", price: 70.59 }
  ],
  "1/16": [
     { refId: 19009, color: "CLEAR / WHITE", finish: "MATTE", price: 75.29 },
     { refId: 29511, color: "YELLOW / BLACK", finish: "SATIN", price: 75.29 },
    { refId: 29515, color: "FOREST GREEN / WHITE", finish: "SATIN", price: 102.00 },
    { refId: 29518, color: "WHITE / BLUE", finish: "SATIN", price: 90.00 },
    { refId: 29514, color: "WHITE / RED", finish: "SATIN", price: 87.00 },
    { refId: 29507, color: "WHITE / BLACK", finish: "SATIN", price: 80.00 },
    { refId: 18998, color: "FOREST GREEN / GOLD", finish: "MATTE", price: 80.00 },
    { refId: 19004, color: "BLACK / GOLD", finish: "MATTE", price: 80.00 },
    { refId: 18999, color: "BURGUNDY / GOLD", finish: "MATTE", price: 79.00 },
    { refId: 18997, color: "WHITE / RED", finish: "MATTE", price: 76.00 },
    { refId: 29519, color: "ROYAL BLUE / WHITE", finish: "SATIN", price: 75.29 },
    { refId: 29522, color: "AIR FORCE BLUE / WHITE", finish: "SATIN", price: 75.29 },
    { refId: 18996, color: "WHITE / BLUE", finish: "MATTE", price: 75.29 },
    { refId: 29510, color: "BLUE / WHITE", finish: "SATIN", price: 75.29 },
    { refId: 29513, color: "APPLE GREEN / WHITE", finish: "SATIN", price: 75.29 },
    { refId: 18990, color: "BLUE / WHITE", finish: "MATTE", price: 75.29 },
    { refId: 19012, color: "APPLE GREEN / WHITE", finish: "MATTE", price: 75.29 },
    { refId: 29492, color: "AIR FORCE BLUE / WHITE", finish: "MATTE", price: 75.29 },
     { refId: 19015, color: "ROYAL BLUE / WHITE", finish: "MATTE", price: 75.29 },
    { refId: 29521, color: "ORANGE / WHITE", finish: "SATIN", price: 75.29 },
     { refId: 29531, color: "ALMOND / BLACK", finish: "SATIN", price: 75.29 },
     { refId: 29529, color: "RED / BLACK", finish: "SATIN", price: 75.29 },
     { refId: 29499, color: "ORANGE / BLACK", finish: "MATTE", price: 75.29 },
     { refId: 70953, color: "SKY BLUE / WHITE", finish: "MATTE", price: 75.29 },
     { refId: 18980, color: "BURGUNDY / WHITE", finish: "MATTE", price: 75.29 },
     { refId: 18987, color: "RED / WHITE", finish: "MATTE", price: 75.29 },
     { refId: 29501, color: "TAUPE / WHITE", finish: "MATTE", price: 75.29 }, 
     { refId: 29496, color: "LIGHT GREY / BLACK", finish: "MATTE", price: 75.29 },
     { refId: 29491, color: "PINE GREEN / WHITE", finish: "MATTE", price: 75.29 },
     { refId: 29491, color: "PINE GREEN / WHITE", finish: "MATTE", price: 75.29 },
     { refId: 29494, color: "NAVY BLUE / WHITE", finish: "MATTE", price: 75.29 },
     { refId: 29493, color: "CHOCOLATE BROWN / WHITE", finish: "MATTE", price: 75.29 },
     { refId: 29508, color: "BLACK / WHITE", finish: "SATIN", price: 75.29 },
     { refId: 29495, color: "BROWN / WHITE", finish: "MATTE", price: 75.29 },
     { refId: 19006, color: "CLEAR / BLACK", finish: "MATTE", price: 75.29 },
     { refId: 18993, color: "YELLOW / BLACK", finish: "MATTE", price: 75.29 },
     { refId: 29498, color: "RED / BLACK", finish: "MATTE", price: 75.29 },
     { refId: 29500, color: "ALMOND / BLACK", finish: "MATTE", price: 75.29 },
     { refId: 19000, color: "ORANGE / WHITE", finish: "MATTE", price: 75.29 },
     { refId: 70954, color: "SKY BLUE / WHITE", finish: "SATIN", price: 75.29 },
     { refId: 29512, color: "RED / WHITE", finish: "SATIN", price: 75.29 },
     { refId: 18981, color: "BLACK / WHITE", finish: "MATTE", price: 75.29 },
     { refId: 18984, color: "WHITE / BLACK", finish: "MATTE", price: 75.29 },
     { refId: 19001, color: "FOREST GREEN / WHITE", finish: "MATTE", price: 75.29 },
     { refId: 76079, color: "BLACK / WHITE", finish: "TEXTURED", price: 75.29 },
     { refId: 76074, color: "BROWN / WHITE", finish: "TEXTURED", price: 75.29 },
     { refId: 76072, color: "BLUE / WHITE", finish: "TEXTURED", price: 86.00 },
     { refId: 76075, color: "PINE GREEN / WHITE", finish: "TEXTURED", price: 75.29 },
     { refId: 76071, color: "RED / WHITE", finish: "TEXTURED", price: 75.29 },
     { refId: 76073, color: "YELLOW / BLACK", finish: "TEXTURED", price: 75.29 },
     { refId: 76069, color: "WHITE / BLACK", finish: "TEXTURED", price: 75.29 }
  ],
  "3/32": [
    { refId: 29688, color: "AIR FORCE BLUE / WHITE", finish: "SATIN", price: 102.35 },
    { refId: 29687, color: "BLACK / WHITE", finish: "SATIN", price: 102.35 },
    { refId: 47321, color: "AZURE BLUE / WHITE", finish: "SATIN", price: 158.00 }
  ],
  "1/8": [
    { refId: 77756, color: "APPLE GREEN / WHITE", finish: "MATTE", price: 117.65 },
    { refId: 77754, color: "YELLOW / BLACK", finish: "MATTE", price: 117.65 },
    { refId: 77758, color: "BLACK / WHITE", finish: "MATTE", price: 117.65 },
    { refId: 77759, color: "RED / WHITE", finish: "MATTE", price: 117.65 },
    { refId: 77757, color: "WHITE / BLACK", finish: "MATTE", price: 117.65 },
    { refId: 77755, color: "BLUE / WHITE", finish: "MATTE", price: 117.65 }
  ]
};
window.METALLEX = {
  "0.020": [
    { refId: 53221, color: "ALUMINIUM / BLACK", finish: "BRUSHED", price: 55.29 },
    { refId: 53222, color: "NEW GOLD / BLACK", finish: "MATTE", price: 55.29 },
    { refId: 53223, color: "GOLD / BLACK", finish: "GLOSSY", price: 55.29 }
  ],
  "1/16": [
    { refId: 21886, color: "NEW GOLD / BLACK", finish: "GLOSSY", price: 61.18 },
    { refId: 21902, color: "SILVER / RED", finish: "GLOSSY", price: 61.18 },
    { refId: 21900, color: "SILVER / BLUE", finish: "GLOSSY", price: 61.18 },
    { refId: 21904, color: "BRONZE / BLACK", finish: "BRUSHED", price: 61.18 },
    { refId: 21889, color: "RADIANT SILVER / BLACK", finish: "MATTE", price: 61.18 },
    { refId: 21914, color: "NEW GOLD / BLACK", finish: "MATTE", price: 61.18 },
    { refId: 21887, color: "SILVER / BLACK", finish: "GLOSSY", price: 61.18 },
    { refId: 21888, color: "RADIANT GOLD / BLACK", finish: "MATTE", price: 61.18 },
    { refId: 21898, color: "ALUMINIUM / BLACK", finish: "BRUSHED", price: 61.18 },
    { refId: 21903, color: "EUROPEAN GOLD / BLACK", finish: "MATTE", price: 61.18 },
    { refId: 23974, color: "ALUMINIUM / BLACK", finish: "GLOSS BRUSHED", price: 69.41 },
    { refId: 21941, color: "ALUMINIUM / BLACK", finish: "MATTE", price: 61.18 }
  ],
  "1/32": [
    { refId: 21825, color: "RADIANT SILVER / BLACK", finish: "MATTE", price: 58.82 },
    { refId: 21826, color: "BRONZE / WHITE", finish: "BRUSHED", price: 58.82 },
    { refId: 21846, color: "NEW GOLD / BLACK", finish: "MATTE", price: 58.82 },
    { refId: 21822, color: "GOLD / BLACK", finish: "GLOSSY", price: 58.82 },
    { refId: 21823, color: "SILVER / BLACK", finish: "GLOSSY", price: 58.82 },
    { refId: 21824, color: "RADIANT GOLD / BLACK", finish: "MATTE", price: 58.82 },
    { refId: 21830, color: "ALUMINIUM / BLACK", finish: "BRUSHED", price: 90.59 },
    { refId: 21836, color: "EUROPEAN GOLD / BLACK", finish: "MATTE", price: 58.82 }
  ],
   "3/32": [
      { refId: 21954, color: "GLOSSY GOLD / BLACK", finish: "GLOSSY", price: 90.59 },
      { refId: 21955, color: "SILVER / BLACK", finish: "GLOSSY", price: 90.59 },
      { refId: 21956, color: "RADIANT GOLD / BLACK", finish: "MATTE", price: 90.59 },
      { refId: 21957, color: "RADIANT SILVER / BLACK", finish: "MATTE", price: 90.59 },
      { refId: 21965, color: "ALUMINIUM / BLACK", finish: "BRUSHED", price: 90.59 },
      { refId: 21969, color: "EUROPEAN GOLD / BLACK", finish: "MATTE", price: 90.59 },
      { refId: 21978, color: "NEW GOLD / BLACK", finish: "MATTE", price: 90.59 }
   ]
};
window.GRAVOPLY_LASER = {
  "0.020": [
    { refId: 72305, color: "BLUE / GOLD", price: 58.00 }
  ],
  "0.050": [
     { refId: 51011, color: "WHITE / BLUE", price: 55.29 },
     { refId: 49977, color: "DARKE YELLOW / BLACK", price: 55.29 },
    { refId: 51015, color: "AIR FORCE BLUE / GOLD", price: 55.29 },
    { refId: 49991, color: "AIR FORCE BLUE / WHITE", price: 55.29 },
    { refId: 49978, color: "ALMOND / BLACK", price: 55.29 },
    { refId: 49996, color: "APPLE GREEN / WHITE", price: 55.29 },
    { refId: 51014, color: "BLACK / GOLD", price: 55.29 },
    { refId: 49987, color: "BLACK / WHITE", price: 55.29 },
    { refId: 51008, color: "BLACK / YELLOW", price: 55.29 },
    { refId: 49989, color: "BLUE / WHITE", price: 55.29 },
    { refId: 51010, color: "BLUE / YELLOW", price: 55.29 },
    { refId: 49993, color: "BROWN / WHITE", price: 55.29 },
    { refId: 51016, color: "BURGUNDY / GOLD", price: 55.29 },
    { refId: 49997, color: "BURGUNDY / WHITE", price: 55.29 },
    { refId: 49994, color: "CHOCOLATE BROWN / WHITE", price: 57.00 },
    { refId: 49974, color: "GREY / BLACK", price: 55.29 },
    { refId: 49992, color: "GREY / WHITE", price: 55.29 },
    { refId: 51001, color: "ORANGE / BLACK", price: 55.29 },
    { refId: 51005, color: "ORANGE / WHITE", price: 55.29 },
    { refId: 49995, color: "PINE GREEN / WHITE", price: 55.29 },
    { refId: 67006, color: "PURPLE / WHITE", price: 55.29 },
    { refId: 49988, color: "RED / WHITE", price: 55.29 },
    { refId: 51009, color: "RED / YELLOW", price: 55.29 },
    { refId: 49990, color: "SKY BLUE / WHITE", price: 55.29 },
    { refId: 51006, color: "WHITE / RED", price: 55.29 },
    { refId: 49971, color: "WHITE / BLACK", price: 55.29 },
    { refId: 49973, color: "YELLOW / BLACK", price: 55.29 },
    { refId: 51012, color: "YELLOW / BLUE", price: 55.29 },
    { refId: 51007, color: "YELLOW / RED", price: 55.29 },
    { refId: 49979, color: "SKY BLUE / BLACK", price: 55.29 }
  ],
  "1/32": [
     { refId: 51037, color: "SKY BLUE / WHITE", price: 52.94 },
     { refId: 51018, color: "YELLOW / BLACK", price: 52.94 },
    { refId: 51061, color: "AIR FORCE BLUE / GOLD", price: 52.94 },
    { refId: 51038, color: "AIR FORCE BLUE / WHITE", price: 52.94 },
    { refId: 51022, color: "ALMOND / BLACK", price: 52.94 },
    { refId: 51042, color: "APPLE GREEN / WHITE", price: 52.94 },
    { refId: 51060, color: "BLACK / GOLD", price: 52.94 },
    { refId: 51033, color: "BLACK / WHITE", finish: "MATTE", price: 52.94 },
    { refId: 51049, color: "BLACK / YELLOW", price: 52.94 },
    { refId: 51036, color: "BLUE / WHITE", price: 52.94 },
    { refId: 51056, color: "BLUE / YELLOW", price: 52.94 },
    { refId: 51044, color: "BROWN / WHITE", price: 52.94 },
    { refId: 51062, color: "BURGUNDY / GOLD", price: 52.94 },
    { refId: 51043, color: "BURGUNDY / WHITE", price: 52.94 },
    { refId: 51019, color: "DARKE YELLOW / BLACK", price: 52.94 },
    { refId: 51023, color: "GREY / BLACK", price: 52.94 },
    { refId: 51046, color: "GREY / WHITE", price: 52.94 },
    { refId: 51020, color: "ORANGE / BLACK", price: 52.94 },
    { refId: 51035, color: "ORANGE / WHITE", price: 52.94 },
    { refId: 51039, color: "PINE GREEN / WHITE", price: 52.94 },
    { refId: 67005, color: "PURPLE / WHITE", price: 52.94 },
    { refId: 51034, color: "RED / WHITE", price: 52.94 },
    { refId: 51055, color: "RED / YELLOW", price: 52.94 },
    { refId: 51057, color: "WHITE / BLUE", price: 52.94 },
    { refId: 51047, color: "WHITE / RED", price: 52.94 },
    { refId: 51017, color: "WHITE / BLACK", price: 52.94 },
    { refId: 51058, color: "YELLOW / BLUE", price: 52.94 },
    { refId: 51048, color: "YELLOW / RED", price: 52.94 },
    { refId: 51021, color: "SKY BLUE / BLACK", price: 52.94 }
  ],
  "1/16": [
     { refId: 70001, color: "BROWN / WHITE", price: 57.65 },
     { refId: 80768, color: "ORANGE / BLACK", price: 59.00 },
    { refId: 74768, color: "AMERICAN WALNUT / WHITE", price: 99.00 },
    { refId: 69999, color: "GREY / WHITE", price: 57.65 },
    { refId: 69994, color: "BLACK / WHITE", price: 57.65 },
    { refId: 70006, color: "YELLOW / RED", price: 74.00 },
    { refId: 69998, color: "AIR FORCE BLUE / WHITE", price: 57.65 },
    { refId: 69993, color: "SKY BLUE / BLACK", price: 57.65 },
    { refId: 69997, color: "SKY BLUE / WHITE", price: 57.65 },
    { refId: 70002, color: "PINE GREEN / WHITE", price: 57.65 },
    // { refId: 70000, color: "BROWN / WHITE", price: 57.65 },
    { refId: 70003, color: "APPLE GREEN / WHITE", price: 57.65 },
    { refId: 70004, color: "BURGUNDY / WHITE", price: 57.65 },
    { refId: 70005, color: "WHITE / RED", price: 75.00 },
    { refId: 69991, color: "WHITE / BLACK", price: 57.65 },
    { refId: 69996, color: "BLUE / WHITE", price: 57.65 },
    { refId: 69992, color: "YELLOW / BLACK", price: 57.65 },
    { refId: 69995, color: "RED / WHITE", price: 57.65 },
    { refId: 81585, color: "RED / BLACK", price: 57.65 }
  ],
  "1/8": [
    { refId: 29707, color: "AMERICAN WALNUT / WHITE", price: 129.41 }
  ]
};
window.GRAVOGLAS_2PLEX_SURFACE = {
  "1/16" : [
      { refId: "34403", color: "ALMOND / BLACK", finish: "MATTE", price: 88.24 },
      { refId: "17933", color: "BLACK / GOLD", finish: "GLOSSY", price: 88.24 },
      { refId: "17907", color: "WHITE / RED", finish: "GLOSSY", price: 88.24 },
      { refId: "17904", color: "WHITE / AZURE BLUE", finish: "GLOSSY", price: 88.24 },
      { refId: "17927", color: "GOLD / BLACK", finish: "GLOSSY", price: 88.24 },
      { refId: "17924", color: "COPPER / BLACK", finish: "GLOSSY", price: 88.24 },
      { refId: "29647", color: "ROYAL BLUE / WHITE", finish: "GLOSSY", price: 88.24 },
      { refId: "29645", color: "CHOCOLATE BROWN / WHITE", finish: "GLOSSY", price: 88.24 },
      { refId: "29644", color: "BROWN / WHITE", finish: "GLOSSY", price: 88.24 },
      { refId: "17895", color: "RED / WHITE", finish: "GLOSSY", price: 88.24 },
      { refId: "17930", color: "SILVER GREY / BLACK", finish: "GLOSSY", price: 88.24 },
      { refId: "17889", color: "BLACK / WHITE", finish: "GLOSSY", price: 88.24 },
      { refId: "17901", color: "YELLOW / BLACK", finish: "GLOSSY", price: 88.24 },
      { refId: "17898", color: "AZURE BLUE / WHITE", finish: "GLOSSY", price: 88.24 },
      { refId: "17892", color: "WHITE / BLACK", finish: "GLOSSY", price: 88.24 },
      { refId: "29639", color: "GREEN / EGGSHELL", finish: "MATTE", price: 165.00 },
      { refId: "29643", color: "BLACK / GOLD", finish: "MATTE", price: 84.00 },
      { refId: "29627", color: "WHITE / RED", finish: "MATTE", price: 76.47 },
      { refId: "29642", color: "GOLD / BLACK", finish: "MATTE", price: 76.47 },
      { refId: "29628", color: "WHITE / AZURE BLUE", finish: "MATTE", price: 76.47 },
      { refId: "29641", color: "METALLIC BLUE / WHITE", finish: "MATTE", price: 76.47 },
      { refId: "29633", color: "ORANGE / BLACK", finish: "MATTE", price: 76.47 },
      { refId: "17877", color: "RED / WHITE", finish: "MATTE", price: 76.50 },
      { refId: "17883", color: "BURGUNDY / WHITE", finish: "MATTE", price: 76.50 },
      { refId: "29636", color: "CHOCOLATE BROWN / WHITE", finish: "MATTE", price: 76.47 },
      { refId: "29637", color: "TEAL / WHITE", finish: "MATTE", price: 76.47 },
      { refId: "17885", color: "APPLE GREEN / WHITE", finish: "MATTE", price: 76.50 },
      { refId: "17887", color: "SILVER GREY / BLACK", finish: "MATTE", price: 76.50 },
      { refId: "47230", color: "ORANGE / WHITE", finish: "MATTE", price: 76.47 },
      { refId: "17881", color: "YELLOW / BLACK", finish: "MATTE", price: 76.50 },
      { refId: "17879", color: "AZURE BLUE / WHITE", finish: "MATTE", price: 76.50 },
      { refId: "17873", color: "BLACK / WHITE", finish: "MATTE", price: 76.50 },
      { refId: "17875", color: "WHITE / BLACK", finish: "MATTE", price: 76.50 },
      { refId: "18337", color: "WHITE / PINE GREEN", finish: "TEXTURED", price: 137.00 },
      { refId: "18325", color: "WHITE / RED", finish: "TEXTURED", price: 76.47 },
      { refId: "18328", color: "BROWN / WHITE", finish: "TEXTURED", price: 76.47 },
      { refId: "18307", color: "RED / WHITE", finish: "TEXTURED", price: 76.47 },
      { refId: "18313", color: "AMERICAN BLUE / WHITE", finish: "TEXTURED", price: 76.47 },
      { refId: "18322", color: "SILVER GREY / BLACK", finish: "TEXTURED", price: 76.47 },
      { refId: "18343", color: "PINE GREEN / WHITE", finish: "TEXTURED", price: 76.47 },
      { refId: "29654", color: "APPLE GREEN / WHITE", finish: "TEXTURED", price: 76.47 },
      { refId: "34404", color: "ALMOND / BLACK", finish: "TEXTURED", price: 76.47 },
      { refId: "18334", color: "YELLOW / BLACK", finish: "TEXTURED", price: 76.47 },
      { refId: "18310", color: "AZURE BLUE / WHITE", finish: "TEXTURED", price: 76.47 },
      { refId: "18301", color: "BLACK / WHITE", finish: "TEXTURED", price: 76.47 },
      { refId: "18304", color: "WHITE / BLACK", finish: "TEXTURED", price: 76.47 },
      { refId: "17910", color: "APPLE GREEN / WHITE", finish: "GLOSSY", price: 88.24 },
      { refId: "17918", color: "PINE GREEN / WHITE", finish: "GLOSSY", price: 88.24 },
    ],
  "1/8" : [
      { refId: "18080", color: "BLACK / GOLD", finish: "GLOSSY", price: 160.00 },
      { refId: "18063", color: "WHITE / RED", finish: "GLOSSY", price: 190.00 },
      { refId: "18075", color: "GOLD / BLACK", finish: "GLOSSY", price: 111.76 },
      { refId: "18069", color: "BURGUNDY / WHITE", finish: "GLOSSY", price: 111.76 },
      { refId: "18078", color: "SILVER GREY / BLACK", finish: "GLOSSY", price: 111.76 },
      { refId: "18054", color: "RED / WHITE", finish: "GLOSSY", price: 111.76 },
      { refId: "29650", color: "CHOCOLATE BROWN / WHITE", finish: "GLOSSY", price: 111.76 },
      { refId: "18066", color: "APPLE GREEN / WHITE", finish: "GLOSSY", price: 111.76 },
      { refId: "18072", color: "PINE GREEN / WHITE", finish: "GLOSSY", price: 111.76 },
      { refId: "18060", color: "YELLOW / BLACK", finish: "GLOSSY", price: 111.76 },
      { refId: "18057", color: "AZURE BLUE / WHITE", finish: "GLOSSY", price: 111.76 },
      { refId: "18048", color: "BLACK / WHITE", finish: "GLOSSY", price: 111.76 },
      { refId: "18051", color: "WHITE / BLACK", finish: "GLOSSY", price: 111.76 },
      { refId: "29910", color: "GOLD / BLACK", finish: "MATTE", price: 111.76 },
      { refId: "29905", color: "RED / WHITE", finish: "MATTE", price: 111.76 },
      { refId: "29906", color: "APPLE GREEN / WHITE", finish: "MATTE", price: 111.76 },
      { refId: "29913", color: "BLACK / WHITE DS", finish: "MATTE", price: 129.41 },
      { refId: "29907", color: "AZURE BLUE / WHITE", finish: "MATTE", price: 111.76 },
      { refId: "29904", color: "WHITE / BLACK", finish: "MATTE", price: 111.76 },
      { refId: "29911", color: "BLACK / WHITE", finish: "MATTE", price: 111.76 },
      { refId: "29912", color: "WHITE / BLACK DS", finish: "MATTE", price: 129.41 },
      { refId: "29917", color: "BLACK / WHITE", finish: "TEXTURED", price: 111.76 },
      { refId: "29908", color: "SILVER GREY / BLACK", finish: "MATTE", price: 134.00 },
      { refId: "18033", color: "AZURE BLUE / CLEAR", finish: "GLOSSY", price: 134.00 },
      ]
  };
window.GRAVOPLY_1 = {
  "1/8": [
    { refId: 29705, color: "Azure Blue / White", finish: "SATIN", price: 120.00 },
    { refId: 29704, color: "Chocolate Brown / White", finish: "SATIN", price: 120.00 },
    { refId: 29706, color: "Navy Blue / White", finish: "SATIN", price: 120.00 },
    { refId: 29702, color: "Red / White", finish: "SATIN", price: 120.00 },
    { refId: 29700, color: "White / Black", finish: "SATIN", price: 120.00 },
    { refId: 29699, color: "White / Red", finish: "SATIN", price: 120.00 },
    { refId: 17521, color: "Black / White", finish: "SATIN", price: 74.00 },
    { refId: 17525, color: "Yellow / Black", finish: "SATIN", price: 74.00 }
  ],
  "1/16": [
    { refId: 17428, color: "Air Force Blue / White", finish: "SATIN", price: 61.00 },
    { refId: 32293, color: "Almond / Black", finish: "SATIN", price: 61.18 },
    { refId: 17425, color: "Almond / Silver Grey", finish: "SATIN", price: 84.00 },
    { refId: 17442, color: "Apple Green / White", finish: "SATIN", price: 61.00 },   
    { refId: 17353, color: "Azure Blue / White", finish: "SATIN", price: 61.00 },
    { refId: 17439, color: "Azure Blue / Yellow", finish: "SATIN", price: 61.00 },
    { refId: 29601, color: "Black / Red", finish: "SATIN", price: 61.18 },
    { refId: 29572, color: "Black / Silver Grey", finish: "SATIN", price: 61.18 },
    { refId: 17295, color: "Black / Translucent White", finish: "SATIN", price: 91.00 },
    { refId: 17319, color: "Black / White", finish: "SATIN", price: 61.00 },
    { refId: 17399, color: "Black / Yellow", finish: "SATIN", price: 61.00 },
    { refId: 17388, color: "Brown / White", finish: "SATIN", price: 61.00 },
    { refId: 17431, color: "Burgundy / Silver Grey", finish: "SATIN", price: 77.00 },
    { refId: 17463, color: "Burgundy / White", finish: "SATIN", price: 61.00 },
    { refId: 29566, color: "Burnt Orange / Black", finish: "SATIN", price: 61.18 },
    { refId: 31641, color: "Chocolate Brown / White", finish: "SATIN", price: 61.18 },
    { refId: 17413, color: "Cocoa / Chocolate Brown", finish: "SATIN", price: 78.00 },
    { refId: 17393, color: "Green / White", finish: "SATIN", price: 61.00 },
    { refId: 17419, color: "Cocoa / White", finish: "SATIN", price: 61.00 },
    { refId: 17310, color: "Ivory / Chocolate Brown", finish: "SATIN", price: 101.00 },
    { refId: 29583, color: "Light Grey / Black", finish: "SATIN", price: 61.18 },
    { refId: 17363, color: "Metallic Blue / White", finish: "SATIN", price: 61.00 },
    { refId: 17376, color: "Grey Metallic / White", finish: "SATIN", price: 61.00 },
    { refId: 29582, color: "Navy Blue / Silver Grey", finish: "SATIN", price: 76.00 },
    { refId: 29581, color: "Navy Blue / White", finish: "SATIN", price: 61.18 },
    { refId: 17404, color: "Orange / Black", finish: "SATIN", price: 61.00 },
    { refId: 17407, color: "Orange / White", finish: "SATIN", price: 61.00 },
    { refId: 17410, color: "Pine Green / White", finish: "SATIN", price: 61.00 },
    { refId: 17436, color: "Purple / White", finish: "SATIN", price: 61.00 },
    { refId: 17454, color: "Red / Black", finish: "SATIN", price: 61.00 },
    { refId: 17301, color: "Red / Translucent White", finish: "SATIN", price: 93.00 },
    { refId: 17506, color: "Red / White", finish: "SATIN", price: 61.00 },
    { refId: 17445, color: "Red / Yellow", finish: "SATIN", price: 61.00 },
    { refId: 17448, color: "Rust / White", finish: "SATIN", price: 61.00 },
    { refId: 17379, color: "Silver Grey / Black", finish: "SATIN", price: 61.00 },
    { refId: 29584, color: "Silver Grey / White", finish: "SATIN", price: 61.18 },
    { refId: 29569, color: "Teal / White", finish: "SATIN", price: 61.18 },
    { refId: 17331, color: "White / Black", finish: "SATIN", price: 61.00 },
    { refId: 17396, color: "White / Blue", finish: "SATIN", price: 64.00 },
    { refId: 17313, color: "White / Green", finish: "SATIN", price: 61.00 },
    { refId: 29561, color: "White / Pine Green", finish: "SATIN", price: 77.00 },
    { refId: 17385, color: "White / Red", finish: "SATIN", price: 61.00 },
    { refId: 17366, color: "Yellow / Black", finish: "SATIN", price: 61.00 },
    { refId: 17373, color: "Yellow / Blue", finish: "SATIN", price: 74.00 },
    { refId: 29565, color: "Yellow / Magenta", finish: "SATIN", price: 61.18 },
    { refId: 29564, color: "Yellow / White", finish: "SATIN", price: 61.18 }
  ],
    "1/32": [
    { refId: 17292, color: "Apple Green / White", finish: "SATIN", price: 55.00 },
    { refId: 17270, color: "Azure Blue / White", finish: "SATIN", price: 55.00 },
    { refId: 17250, color: "Black / White", finish: "SATIN", price: 55.00 },
    { refId: 29560, color: "Burnt Orange / Black", finish: "SATIN", price: 55.29 },
    { refId: 17267, color: "Red / White", finish: "SATIN", price: 55.00 },
    { refId: 17276, color: "Silver Grey / Black", finish: "SATIN", price: 55.00 },
    { refId: 17263, color: "White / Black", finish: "SATIN", price: 55.00 },
    { refId: 17284, color: "White / Blue", finish: "SATIN", price: 55.00 },
    { refId: 17273, color: "Yellow / Black", finish: "SATIN", price: 55.00 }
  ],
    "3/32": [
    { refId: 17475, color: "Azure Blue / White", finish: "SATIN", price: 82.00 },
    { refId: 17467, color: "Black / White", finish: "SATIN", price: 82.00 },
    { refId: 17467, color: "Black / White", finish: "SATIN", price: 82.00 },
    { refId: 17472, color: "Red / White", finish: "SATIN", price: 82.00 },
    { refId: 17481, color: "Silver Grey / Black", finish: "SATIN", price: 82.00 },
    { refId: 17489, color: "White / Blue", finish: "SATIN", price: 124.00 },
    { refId: 17484, color: "White / Red", finish: "SATIN", price: 93.00 },
    { refId: 17478, color: "Yellow / Black", finish: "SATIN", price: 82.00 }
  ]
}
